// Inicializar al cargar la página
document.addEventListener("DOMContentLoaded", function(){
  
  function convertPricesTo(currency){
    document.querySelectorAll(".money").forEach(ev => {
      const base = parseFloat(ev.dataset.basePrice);
      const format = new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      if(!isNaN(base)){
        const convert = Currency.convert(base, "MXN", currency);
        const price = format.format(convert % 1 === 0 ? convert.toFixed(0) : convert.toFixed(2));
        ev.textContent = `$ ${price}`;
      }
    });
  }
  
  function convertPrices(price){
    const currency = localStorage.getItem("preferredCurrency") || "MXN";
      const base = parseFloat(price);
      const format = new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      if(!isNaN(base)){
        const convert = Currency.convert(base, "MXN", currency);
        const price = format.format(convert % 1 === 0 ? convert.toFixed(0) : convert.toFixed(2));
        return `$ ${price}`;
      }
  }
  
  function readyConvert(){
      // Guardar precio base si no está ya guardado
      document.querySelectorAll(".money").forEach(ev => {
        //console.log(ev.dataset.basePrice);
        if(!ev.dataset.basePrice){
          const raw = parseFloat(ev.textContent.replace(/[^0-9.]/g, ""));
        }
      });
    
      // Aplicar moneda almacenada en localStorage
      const savedCurrency = localStorage.getItem("preferredCurrency") || "MXN";
      convertPricesTo(savedCurrency);
  }
  
  // Cambiar moneda al seleccionar
  document.getElementById("currencies").addEventListener("change", function(){
    const selectedCurrency = this.value;
    localStorage.setItem("preferredCurrency", selectedCurrency);
    convertPricesTo(selectedCurrency);
  });

  
  /*document.querySelectorAll("form[action='/cart/add'] button[name='add']").forEach(button => {
    button.addEventListener("click", () => {
      
      
      setTimeout(function(){
        readyConvert();
        }, 2000
      ); // da tiempo a que el DOM se actualice
    });
  });*/
  
  const loadScript = src => new Promise(resolve => {
    const script = document.createElement("script");
    script.src = src;
    script.addEventListener("load", resolve);
    document.head.appendChild(script);
  })

  async function loadAndExecuteScript(){
    await loadScript("//cdn.shopify.com/s/javascripts/currencies.js");
    readyConvert();
  }

  loadAndExecuteScript();
});
